import React from 'react';
import { Field, FormSection } from 'redux-form';

function DetailSection(props) {
  const { 
    languageKey, 
    textAreaComponent, 
    fieldComponent,
    contentEditor,
  } = props;
  const lang = languageKey.toUpperCase();

  return (
    <React.Fragment>
      <FormSection
        name="desc"
      >
        {/* <Field
          label={`Description (${lang})`}
          name={languageKey}
          placeholder="Description"
          component={textAreaComponent}
          required={languageKey === 'zh'}
        /> */}
        {contentEditor}
      </FormSection>
      {/* <FormSection
        name="ingredients"
      >
        <Field
          label={`Ingredients / Materials (${lang})`}
          name={languageKey}
          placeholder="Ingredients / Materials"
          component={textAreaComponent}
        />
      </FormSection>
      <FormSection
        name="cautions"
      >
        <Field
          label={`Cautions (${lang})`}
          name={languageKey}
          placeholder="Cautions"
          component={textAreaComponent}
        />
      </FormSection>
      <FormSection
        name="packing_quantity"
      >
        <Field
          label={`Packing Quantity (${lang})`}
          name={languageKey}
          placeholder="Packing Quantity"
          component={fieldComponent}
        />
      </FormSection> */}
    </React.Fragment>
  );
}

export default DetailSection;



// WEBPACK FOOTER //
// ./src/views/products/form-sections/DetailSection.jsx